import axiosInstance from "./axiosInstance";

export const getNotifications = (page = 1, unread_only = false, type = '') => {
  const params = new URLSearchParams({ page });
  if (unread_only) params.set('unread_only', 'true');
  if (type) params.set('type', type);
  return axiosInstance.get(`/notifications/?${params}`);
};

export const getUnreadCount = () =>
  axiosInstance.get('/notifications/unread-count/');

export const markRead = (id) =>
  axiosInstance.post(`/notifications/read/${id}/`);

export const markAllRead = (ids = null) =>
  axiosInstance.post('/notifications/read-all/', ids ? { ids } : {});
